import { bootstrapApplication } from '@angular/platform-browser';
import { initAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadDefaultConfigs } from '@sxm-core/utility-code/typescript/browser-load-app-configs';
import { bootstrapWebSdk } from '@sxm-de/dev-kits/web-sdk/core';

async function load() {
    const configs = await loadDefaultConfigs();

    const {
        appUrls,
        settings,
        countryCode,
        featureFlags,
        locale,
        microservices,
        thirdParty,
        logging,
    } = configs;
    const { clientSdkConfig } = settings;
    const { sentry } = logging;
    const webSdk = await bootstrapWebSdk({
        appUrls,
        clientSdkConfig,
        countryCode,
        featureFlags,
        locale,
        microservices,
        sentry,
        thirdParty,
    });

    return { configs, webSdk };
}

load().then(({ configs, webSdk }) => {
    bootstrapApplication(AppComponent, initAppConfig(configs, webSdk)).catch(
        (err) => console.error(err),
    );
});
